import React, { useCallback, useEffect, useReducer, useRef, useState } from "react";

import Table from "./partials/Table";
import FilterForm from "./partials/FilterForm";
import { useCookies } from "react-cookie";
import { useLocation } from "react-router-dom";
import { parseQuerySimple } from "../../../helper/urlHelper";
import { getListGroupedFull, getCsv } from '../../../controller/api/__loto__/cart'
import { calculatePage } from "../../../helper/helper";
import Summary from "./partials/Summary";
import ExportProcessingPopup from "../../../components/ExportProcessingPopup";

export const Context = React.createContext(null);

const initialData = {
  activeTab: 'all',
  filter: {
    from: new Date(),
    to: new Date(),
    phone: '',
    name: '',
    cartId: '',
    region: '',
    gameId: '',
    isDone: -1,
    statusGroup: undefined,
    page: 0
  },
  data: {
    list: [],
    total: 0,
    totalPage: 0
  },
  loading: false,
  filterPressCount: 0,
  exportPressCount: 0,
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SUBMIT_FILTER':
      return {
        ...state,
        filter: {
          ...state.filter,
          ...action.payload,
          page: 0
        },
        filterPressCount: state.filterPressCount + 1
      }
    case 'SET_ACTIVE_TAB':
      const nextIsDone = action.payload === 'new' ? 0 : ['waiting_result', 'has_result'].includes(action.payload) ? 1 : -1
      const nextStatusGroup = action.payload === 'new'
        ? 'new'
        : action.payload === 'waiting_result'
          ? 'waiting_result'
          : action.payload === 'has_result'
            ? 'has_result'
            : undefined
      return {
        ...state,
        activeTab: action.payload,
        filter: {
          ...state.filter,
          isDone: nextIsDone,
          statusGroup: nextStatusGroup,
          page: 0
        },
        filterPressCount: state.filterPressCount + 1
      }
    case 'UPDATE_DATA':
      return {
        ...state,
        data: {
          ...action.payload
        }
      }
    case 'SET_LOADING':
      return {
        ...state,
        loading: action.payload
      }
    case 'EXPORT_DATA':
      return {
        ...state,
        exportPressCount: state.exportPressCount + 1
      }
    case 'UPDATE_PAGE':
      return {
        ...state,
        filter: {
          ...state.filter,
          page: action.payload
        }
      }
    default:
      return {
        ...state
      }
  }
}

const buildStateFromQuery = (search) => {
  const { cartId } = parseQuerySimple(search)

  if (!cartId) return initialData

  // Looking up one cart must also reach records older than the default day range.
  return {
    ...initialData,
    filter: {
      ...initialData.filter,
      cartId,
      from: undefined,
      to: undefined
    }
  }
}

export default function LotoCart() {

  const location = useLocation();

  var [state, dispatch] = useReducer(reducer, location.search, buildStateFromQuery);

  const lastSearchRef = useRef(location.search)

  const [showProcessingModal, setShowProcessingModal] = useState(false)

  const [cookies] = useCookies(['lottmekong'])

  useEffect(() => {
    if (lastSearchRef.current === location.search) return;
    lastSearchRef.current = location.search;

    dispatch({
      type: 'SUBMIT_FILTER',
      payload: buildStateFromQuery(location.search).filter
    })
  }, [location.search])

  const getAllFunc = useCallback(async () => {
    const query = {
      phone: state.filter.phone || undefined,
      name: state.filter.name || undefined,
      cartId: state.filter.cartId || undefined,
      region: state.filter.region || undefined,
      gameId: state.filter.gameId || undefined,
      from: state.filter.from,
      to: state.filter.to,
    }

    if (state.filter.isDone !== -1) {
      query.isDone = state.filter.isDone
    }
    if (state.filter.statusGroup) {
      query.statusGroup = state.filter.statusGroup
    }

    dispatch({
      type: 'SET_LOADING',
      payload: true
    })

    try {
      const response = await getListGroupedFull(cookies.lottmekong, query, state.filter.page)

      if (response) {
        dispatch({
          type: 'UPDATE_DATA',
          payload: {
            list: response.data,
            total: response.total,
            totalPage: calculatePage(response.total)
          }
        })
      }
    } finally {
      dispatch({
        type: 'SET_LOADING',
        payload: false
      })
    }
  }, [cookies.lottmekong, state.filter.from, state.filter.to, state.filter.page, state.filter.phone, state.filter.name, state.filter.cartId, state.filter.region, state.filter.gameId, state.filter.isDone, state.filter.statusGroup])

  useEffect(() => {
    getAllFunc()
  }, [getAllFunc, state.filterPressCount, state.filter.page])

  useEffect(() => {
    if (state.exportPressCount > 0) {
      setShowProcessingModal(true)
    }
  }, [state.exportPressCount])

  const fetchCsvPage = useCallback((csvPage, dates) => {
    const query = {
      phone: state.filter.phone || undefined,
      name: state.filter.name || undefined,
      cartId: state.filter.cartId || undefined,
      region: state.filter.region || undefined,
      gameId: state.filter.gameId || undefined,
      from: dates.from,
      to: dates.to,
    }

    if (state.filter.isDone !== -1) {
      query.isDone = state.filter.isDone
    }
    if (state.filter.statusGroup) {
      query.statusGroup = state.filter.statusGroup
    }

    return getCsv(cookies.lottmekong, query, csvPage)
  }, [cookies.lottmekong, state.filter.phone, state.filter.name, state.filter.cartId, state.filter.region, state.filter.gameId, state.filter.isDone, state.filter.statusGroup])

  useEffect(() => {
    if (state.activeTab === 'new') {
      document.title = "Đơn mới Loto"
      return
    }
    if (state.activeTab === 'waiting_result') {
      document.title = "Đơn chờ KQ Loto"
      return
    }
    if (state.activeTab === 'has_result') {
      document.title = "Đơn có kết quả Loto"
      return
    }
    document.title = "Đơn hàng Loto"
  }, [state.activeTab]);

  return (
    <Context.Provider value={{
      state,
      dispatch
    }}>

      <FilterForm />

      <br />

      <Summary />

      <br />

      <Table />

      <ExportProcessingPopup
        show={showProcessingModal}
        defaultFrom={state.filter.from}
        defaultTo={state.filter.to}
        fetchPage={fetchCsvPage}
        onHide={() => setShowProcessingModal(false)}
      />
    </Context.Provider>
  );
}
